<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="fileName" label="媒体名称"> </el-table-column>
      <el-table-column prop="fileUrl" label="媒体路径"> </el-table-column>
      <el-table-column prop="createTime" label="时间"> </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加媒体文件' : '修改媒体文件'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="媒体名称" prop="fileName">
            <el-input v-model="editOne.fileName"></el-input>
          </el-form-item>
          <el-form-item label="媒体上传">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp4UploadAction()"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击上传媒体</el-button>
            </el-upload>
          </el-form-item>
          
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createMedia"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateMedia"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        fileName: [{ required: true, message: "请输入媒体名称", trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      fileList: [],
      file: "",
    };
  },
  methods: {
    Mp4UploadAction() {
      return process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/uploadFile';
    },
    getTableData(pageIndex) {
      // 获取媒体列表
      this.pageInfo.page = pageIndex
      this.loading = true
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/listPage',
        method: 'GET',
        params: {
          fileNmae: 0,
          pageNum: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize
        },
      }).then(res => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.pageCount);
        }
      })
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          fileName: "",
          md5: "",
          fileUrl: ""
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          fileName: index.fileName,
          md5: index.md5,
          fileUrl: index.fileUrl
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateMedia() {
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/update',
        method: 'post',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(this.editOne)
      }).then(res => {
        if (res.data.code === 1000) {
          this.dialogVisible = false;
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    createMedia() {
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/save',
        method: 'post',
        headers:{
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(this.editOne)
      }).then(res => {
        if (res.data.code === 1000) {
          this.dialogVisible = false;
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        axios({
          url: process.env.VUE_APP_BASE_API+'/v1/mediaRoom/manager/delete',
          method: 'post',
          data: qs.stringify({id:id})
        }).then(res => {
          if (res.data.code === 1000) {
            this.$message.success("删除成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1000) {
        this.$message.success("上传成功");
        this.editOne.md5 = res.data.md5;
        this.editOne.fileUrl = res.data.fileUrl;
      } else {
        this.$message.error("错误，" + res.message);
      }
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log('file',file)
      // console.log('testmsg',testmsg)
      // const extension = testmsg === "mp4";
      // console.log('extension',extension)
      if (testmsg==='mp4'||testmsg==='jpg'||testmsg==='png') {
        return true;
      }else{{
        this.$message({
          message: "上传文件只能是jpg、png图片和视频mp4格式！",
          type: "error",
        });
        return false;
      }}
      
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.audio-content {
  width: 100%;
  .el-form-item__content{
	  height:auto !important;
  }
}
</style>